var _path, _path2, _path3, _path4, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPdfDownload(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 51,
    viewBox: "0 0 60 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0H47.1021L59.8953 10.2326V50.9454H0.581508L0 0Z",
    fill: "#FFDB43",
    fillOpacity: 0.21
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M46.8086 11.0143V0.289551L59.9994 11.0143H46.8086Z",
    fill: "#FFDB43"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24.8218 15.144C24.8218 15.568 24.7218 15.968 24.5218 16.344C24.3218 16.72 24.0018 17.028 23.5618 17.268C23.1218 17.5 22.5578 17.616 21.8698 17.616H20.3578V21H18.9898V12.66H21.8698C22.5098 12.66 23.0498 12.772 23.4898 12.996C23.9378 13.212 24.2698 13.508 24.4858 13.884C24.7098 14.26 24.8218 14.68 24.8218 15.144ZM21.8698 16.5C22.3898 16.5 22.7778 16.384 23.0338 16.152C23.2898 15.912 23.4178 15.576 23.4178 15.144C23.4178 14.232 22.9018 13.776 21.8698 13.776H20.3578V16.5H21.8698ZM28.8506 12.66C29.7386 12.66 30.5146 12.832 31.1786 13.176C31.8506 13.512 32.3666 14 32.7266 14.64C33.0946 15.272 33.2786 16.012 33.2786 16.86C33.2786 17.708 33.0946 18.444 32.7266 19.068C32.3666 19.692 31.8506 20.172 31.1786 20.508C30.5146 20.836 29.7386 21 28.8506 21H26.1266V12.66H28.8506ZM28.8506 19.884C29.8266 19.884 30.5746 19.62 31.0946 19.092C31.6146 18.564 31.8746 17.82 31.8746 16.86C31.8746 15.892 31.6146 15.136 31.0946 14.592C30.5746 14.048 29.8266 13.776 28.8506 13.776H27.4946V19.884H28.8506ZM39.5424 12.66V13.776H36.0024V16.236H38.7624V17.352H36.0024V21H34.6344V12.66H39.5424Z",
    fill: "#ED8E36"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.0005 30C29.0005 29.4477 29.4482 29 30.0005 29C30.5528 29 31.0005 29.4477 31.0005 30V37.1578L34.2433 33.915L35.6575 35.3292L30.0006 40.9861L24.3438 35.3292L25.758 33.915L29.0005 37.1575V30Z",
    fill: "#FFDB43"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22 39H24V43H36V39H38V43C38 44.1046 37.1046 45 36 45H24C22.8954 45 22 44.1046 22 43V39Z",
    fill: "#FFDB43"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPdfDownload);
export default __webpack_public_path__ + "static/media/pdfDownload.cb5a42688be0d785215f92f88f226e9e.svg";
export { ForwardRef as ReactComponent };